var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "50px",
    width: "49px",
    viewBox: "120.941 100.085 224.523 223.963",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9999999999999998, 0, 0, 0.9999999999999998, -7.105427357601002e-15, -7.105427357601002e-15)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 214.446,
    cy: 175.672,
    rx: 22.676,
    ry: 22.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 253.919,
    cy: 260.219,
    rx: 22.676,
    ry: 22.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 305.432,
    cy: 194.709,
    rx: 22.676,
    ry: 22.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 269.037,
    cy: 131.999,
    rx: 22.676,
    ry: 22.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 169.933,
    cy: 277.016,
    rx: 22.676,
    ry: 22.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 143.617,
    cy: 196.389,
    rx: 22.676,
    ry: 22.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 174.972,
    cy: 123.041,
    rx: 22.676,
    ry: 22.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 322.788,
    cy: 257.419,
    rx: 22.676,
    ry: 22.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 281.355,
    cy: 279.815,
    rx: 22.676,
    ry: 22.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 216.406,
    cy: 301.092,
    rx: 22.676,
    ry: 22.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 192.89,
    cy: 204.787,
    rx: 22.676,
    ry: 22.956
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)"
    },
    cx: 259.519,
    cy: 208.147,
    rx: 22.676,
    ry: 22.956
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPile);
export default __webpack_public_path__ + "static/media/pile.7b6e89c4c9d3069348684edf0e3c01db.svg";
export { ForwardRef as ReactComponent };